export default __webpack_public_path__ + "static/media/trustSuccess.f7dfe5c9.svg";